<template>
  <div class="details">
    <div class="details-nav">
      <div class="nav-box">
        <div class="nav-box-img">
          <el-image :lazy="true" :src="require('../../assets/image/details/position.png')" fit="fill"></el-image>
        </div>
        <div>当前位置：</div>
        <div class="details-bread">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/resource/all',query:{ref:'ref99999'} }">资源</el-breadcrumb-item>
            <el-breadcrumb-item>{{bookDetails.bookName}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

      </div>
    </div>
    <div class="deataols-item">
      <div class="item-left">
        <div class="image-border" v-if="bookDetails.coverPicture=='/'">
          <div class="image-content">
            <div class="image-content-bg">
              <div class="image-content-border">
                <div class="image-content-text">
                  {{bookDetails.bookName}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-image :src="bookDetails.coverPicture" fit="fill" v-else></el-image>

        <div style="margin-left:10px;margin-top:10px;margin-bottom:10px;text-align: center;" v-show="bookDetails.price">
          价格: {{ bookDetails.price / 100 }} 元
        </div>
        <div style="display: flex;justify-content: center;" v-show="bookDetails.price">
          <div @click="jumpClick($route.query.bookId,1)" class="r-search-button"> 点击购买</div>
        </div>
      </div>
      <div class="item-right">
        <div class="item-right-top">
          <div class="right-top-class">
            古籍
          </div>
          <div class="right-top-txt">
            {{bookDetails.bookName}}
          </div>
        </div>
        <div class="text-button">
          <div @click="jumpClick($route.query.bookId,1)" class="text-button-wid">
            <svg class="icon" height="18" p-id="3216" t="1644203588284" version="1.1" viewBox="0 0 1024 1024" width="18" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M996.955405 145.54762c-1.815156-0.265292-18.696111-2.59707-48.78582-2.59707-56.241924 0-155.614757 8.377645-283.178365 52.30443 131.040331-74.211972 265.208316-80.983902 267.037436-80.983902a20.609007 20.609007 0 0 0-1.661566-41.190088c-8.531235 0.349069-167.134019 7.986688-313.882435 102.877481 110.975871-103.589581 273.278781-134.977824 275.415081-135.438594a20.650895 20.650895 0 0 0 16.517924-24.001954C905.862478 2.680846 881.204276 0.600398 884.443632 0c-11.826442 2.178188-272.008172 52.262542-372.567838 244.278167C411.106687 52.70935 151.399691 2.666884 139.615137 0.474733a20.609007 20.609007 0 0 0-7.442141 40.491951c2.164225 0.40492 164.760352 31.667498 275.722261 135.620111C261.035139 81.556374 102.181027 73.876867 93.649791 73.541761a20.609007 20.609007 0 1 0-1.647603 41.190088c1.843082 0.083776 136.192583 6.604377 267.442355 81.137492-127.745124-44.010562-227.243622-52.444058-283.541396-52.444058-30.089708 0-46.998589 2.359703-48.869596 2.624996A30.941436 30.941436 0 0 0 0.685857 178.960461l51.341001 684.900407a30.969361 30.969361 0 0 0 29.74064 28.609658c254.359266 9.11767 409.946097 124.142737 411.481999 125.273719a30.91351 30.91351 0 0 0 32.393561 3.029915 30.508591 30.508591 0 0 0 7.274588-5.04055c19.226695-13.683487 169.745051-115.192619 409.3457-123.75178a30.955398 30.955398 0 0 0 29.726677-28.595695l51.313076-684.91437a30.955398 30.955398 0 0 0-26.361657-32.924145zM480.920396 937.05356c-65.443371-36.680123-193.090755-93.55037-369.300556-105.027743L64.677102 205.433819c3.448797-0.083776 7.162887-0.167553 11.170194-0.167553 71.209983 0 216.939118 14.437475 405.087063 108.909386z m431.44872-105.502476c-176.209801 11.379635-303.857186 68.347621-369.314519 105.01378V313.756769c188.147945-94.56965 333.905006-108.909386 405.114988-108.909385q5.990016 0 11.170194 0.125665z m0 0"
                p-id="3217">

              </path>
            </svg>
            <div>
              {{ setDatas() }}
            </div>
          </div>
        </div>
        <div class="right-box">
          <div class="right-box-item" v-show="bookDetails.collectionplace">
            <div class="right-box-theme">地区</div>
            :
            <div class="right-box-content">{{bookDetails.collectionplace}}</div>
          </div>
          <div class="right-box-item" v-show="bookDetails.address">
            <div class="right-box-theme">收藏地</div>
            :
            <div class="right-box-content">{{bookDetails.address}}</div>
          </div>
          <div class="right-box-item" v-show="bookDetails.category">
            <div class="right-box-theme">类别</div>
            :
            <div class="right-box-content">{{bookDetails.category}}</div>
          </div>
          <div class="right-box-item" v-show="bookDetails.nation">
            <div class="right-box-theme">民族</div>
            :
            <div class="right-box-content">{{bookDetails.nation}}</div>
          </div>
          <div class="right-box-item" v-show="bookDetails.pages">
            <div class="right-box-theme">页数</div>
            :
            <div class="right-box-content">{{bookDetails.pages}}</div>
          </div>
          <div class="right-box-item right-box-item2" v-show="bookDetails.brief">
            <div class="right-box-theme">简介</div>
            :
            <div class="right-box-content">
              {{bookDetails.brief}}
              <!-- 不分卷，1册，36页。佚名撰，清光绪二十八年（1902年）抄本。绵纸，线订册页装，抄本前部分为汉文抄录，
              杂有壮族古壮字和毛南族土俗字，后部分以毛南族土俗字誊录，墨书。页面高21厘米，宽14.5厘米，每半页7行
              ，行14-16字。入选第二批《国家珍贵古籍名录》，编号06856。《紅筵滿供之本》内文为汉文、壮族古壮字、
              毛南族土俗字合璧，有朱色句读，书页完好，抄写年代确切，对研究毛南族历史、文化、信仰、习俗、语言、
              文字等有重要参考价值。 -->
            </div>
          </div>
        </div>
        <div class="right-box" style="margin-top:0.521rem;">
          <div class="right-box-item right-box-item2">
            <!-- <div class="right-box-theme" style="min-width:6rem">相关底本资源</div>: -->
            <!-- <div class="right-box-theme" style="min-width:6rem">相关视频资源</div>: -->
            <div class="right-box-theme" style="min-width:6rem">相关资源</div>:

            <div class="right-box-content" v-if="cataData.length!=0">
              <div :key="index" @click="rowClick(item)" class="content-box" v-for="(item, index) in cataData">
                <el-image :src="computers(item)"></el-image>
                <div class="content-items">{{ item.title }}</div>
              </div>
              <div @click="dialogTableVisible = true" class="content-items" style="color:red;cursor: pointer;" v-if="count>5">
                查看更多
              </div>
            </div>
            <div class="right-box-content" v-else>暂无资源</div>
          </div>
        </div>
      </div>
    </div>
    <div class="details-catalogue">
      <div class="details-catalogue-top">
        <el-image :lazy="true" :src="require('../../assets/image/details/detail_bd.png')" fit="fill"></el-image>
        <div class="catalogue-txt">目录</div>
      </div>
      <div class="catalogue-hen"></div>
      <div :key="index" class="details-catalogue-box" v-for="(item, index) in Master.catalogues">
        <div class="catalogue-box-title">{{ Master.bookName }} 第{{ item.page }}页</div>
        <div @click="jumpClick(item.bookId,item.page)" class="catalogue-caozuo" style="cursor: pointer;">查看</div>
      </div>
      <div class="catalogue-hen hen1"></div>
    </div>
    <div class="details-recommend">
      <el-tabs @tab-click="init" v-model="activeName">
        <el-tab-pane name="GJ">
          <template slot="label">
            <div class="tabs-image">
              <el-image :lazy="true" :src="require('../../assets/image/details/detail_bd.png')" fit="fill"></el-image>
              <div>古籍推荐</div>
            </div>
          </template>
          <div class="swich">
            <div @click="imageLeft" class="swich-left">
              <el-image :src="require('../../assets/image/details/leftsclick.png')" fit="fill"></el-image>
            </div>
            <div class="index-swich-posi" ref="posi">
              <div class="swich-banners" ref="swichs">
                <div :key="index" @click="$router.push({path:'/resource/detail',query:{bookId:item.bookId}})" class="banner-item" v-for="(item, index) in recom.booksList">
                  <el-image :src="item.pic == '/' ? require('../../assets/image/index/swich_banner.png'):item.pic" fit="fill"></el-image>
                  <div class="banner-title">{{ item.title }}</div>
                </div>
              </div>
            </div>

            <div @click="imageRight" class="swich-right">
              <el-image :src="require('../../assets/image/details/leftsclick.png')" fit="fill"></el-image>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="视频推荐" name="SP">
          <template slot="label">
            <div class="tabs-image">
              <el-image :lazy="true" :src="require('../../assets/image/details/detail_bd.png')" fit="fill"></el-image>
              <div>视频推荐</div>
            </div>
          </template>
          <div class="swich">
            <div @click="videoLeft" class="swich-left">
              <el-image :src="require('../../assets/image/details/leftsclick.png')" fit="fill"></el-image>
            </div>
            <div class="index-swich-posi swich-video" ref="videoposi">
              <div class="swich-banners" ref="videoswichs">
                <div :key="index" @click="$router.push({path:'/resource/videoshows',query:{bookId:item.bookId}})" class="banner-item" v-for="(item, index) in recom.videoList">

                  <el-image :src="item.pic == '/' ? require('../../assets/image/index/video_image.png'):item.pic" fit="fill"></el-image>
                  <div class="banner-title">{{ item.title }}</div>
                </div>
              </div>
            </div>
            <div @click="videoRight" class="swich-right">
              <el-image :src="require('../../assets/image/details/leftsclick.png')" fit="fill"></el-image>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="音频推荐" name="YP">
          <template slot="label">
            <div class="tabs-image">
              <el-image :lazy="true" :src="require('../../assets/image/details/detail_bd.png')" fit="fill"></el-image>
              <div>音频推荐</div>
            </div>
          </template>
          <div class="swich">
            <div @click="audioLeft" class="swich-left">
              <el-image :src="require('../../assets/image/details/leftsclick.png')" fit="fill"></el-image>
            </div>
            <div class="index-swich-posi swich-video" ref="audioposi">
              <div class="swich-banners" ref="audioswichs">
                <div :key="index" @click="$router.push({path:'/resource/detailsAud',query:{bookId:item.bookId}})" class="banner-item" v-for="(item, index) in recom.audioList">
                  <el-image :src="item.pic == '/'?require('../../assets/image/index/audiobg.png'):item.pic" fit="fill"></el-image>
                  <div class="banner-title">{{ item.title }}</div>
                </div>
              </div>
            </div>
            <div @click="audioRight" class="swich-right">
              <el-image :src="require('../../assets/image/details/leftsclick.png')" fit="fill"></el-image>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <Login ref="Login"/>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogTableVisible" title="相关资源" width="30%">
      <el-table :data="cataData" :header-cell-style="{fontSize: '0.833rem',color: '#333',backgroundColor: '#f3f3f3',height:'2.083rem'}" @row-click="rowClick" border style="margin-bottom:15px">
        <el-table-column label="bookId" property="bookId"></el-table-column>
        <el-table-column label="题名" property="title"></el-table-column>
        <el-table-column class="dsse" label="分类" property="name">
          <template slot-scope="scope">
            <div style="display: flex;align-items: center;">
              <el-image :src="computers(scope.row)" style="display: flex;margin-right: 5px;"></el-image>
              <div>
                {{ scope.row.relatedType == 0?'关联资源': scope.row.relatedType == 1?'翻译本': scope.row.relatedType == 2?'音频': scope.row.relatedType == 3?'视频':''}}
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :limit="limit" :total="10" @handleCurrentChange="handerChange"></Pagination>
    </el-dialog>
  </div>
</template>

<script>
  import Login from "../../components/common/login/Login.vue"
  import Pagination from "../../components/common/Pagination";
  import {addReadHistory, getBookById, getMasterSlaveCatalogue, listBookRelationByBookId} from '../../api/resource'
  import {checkIfPermittedToRead} from '../../api/buying'
  import {listHomePageRecommend} from "../../api/index"

  export default {
    name: 'PortalDetails',
    components: {
      Login, Pagination
    },
    data() {
      return {
        title: '紅筵滿供之本',
        activeName: 'GJ',
        // 精品图书
        index: 0,
        childLendth: 0,
        timeout: false,
        // 民宿视频
        vindex: 0,
        vchildLendth: 0,
        vtimeout: false,
        // 民俗音频
        aindex: 0,
        achildLendth: 0,
        atimeout: false,
        datalist: [],
        bookDetails: {
          bookName: '',
          // 地区
          address: '',
          // 收藏地
          collectionplace: '',
          // 类别
          category: '',
          // 民族
          nation: '',
          // 页数
          pages: '',
          // 简介
          brief: '',
          // 价格
          price: '',
          coverPicture: ''
        },
        recom: {
          audioList: [],
          videoList: [],
          booksList: []
        },
        detailsName: '',
        cataData: [],
        Master: [],
        dialogTableVisible: false,
        currPage: 1,
        limit: 5,
        count: 0,
      };
    },

    mounted() {
      this.getDetail()
      this.getMaster()
      this.getInit()
      this.getCataDatas()
    },

    methods: {
      handleClick(tab, event) {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        // if(tab.index==0){
        //     this.$nextTick(()=>{
        //         let swich = this.$refs.swichs
        //         if(swich.children.length != 0){
        //             for (const key of swich.children) {
        //                 this.childLendth+=key.offsetWidth
        //             }
        //             this.$refs.posi.style = 'max-width:'+swich.children[0].offsetWidth *6/fontSize +'rem'
        //         }
        //     });
        // }else if(tab.index==1){
        //     this.$nextTick(()=>{
        //         let swich = this.$refs.videoswichs
        //         if(swich.children.length != 0){
        //             for (const key of swich.children) {
        //                 this.vchildLendth+=key.offsetWidth
        //             }
        //             this.$refs.videoposi.style = 'max-width:'+swich.children[0].offsetWidth *3/fontSize +'rem'
        //         }
        //     });
        // }else if(tab.index==2){
        //     this.$nextTick(()=>{
        //         let swich = this.$refs.audioswichs
        //         if(swich.children.length != 0){
        //             for (const key of swich.children) {
        //                 this.childLendth+=key.offsetWidth
        //             }
        //             this.$refs.audioposi.style = 'max-width:'+swich.children[0].offsetWidth *3/fontSize +'rem'
        //         }
        //     });
        // }
      },
      imageLeft() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.posi
        let swich = this.$refs.swichs

        if (posi.offsetWidth > this.childLendth) {

        } else {
          let that = this
          if (posi.getBoundingClientRect().left - swich.getBoundingClientRect().left == this.childLendth - posi.offsetWidth) {
            return
          } else {
            if (this.timeout) return
            window.requestAnimationFrame(function fn() {
              that.index -= 1
              const width = (that.index * that.$refs.swichs.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.timeout = true
              swich.addEventListener("transitionend", () => {
                that.timeout = false
              })
            })
          }
        }
      },
      imageRight() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.posi
        let swich = this.$refs.swichs
        if (posi.offsetWidth > this.childLendth) {

        } else {
          if (posi.getBoundingClientRect().left == swich.getBoundingClientRect().left) {
            return
          } else {
            let that = this
            if (this.timeout) return
            window.requestAnimationFrame(function fn() {
              that.index += 1
              const width = (that.index * that.$refs.swichs.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.timeout = true
              swich.addEventListener("transitionend", () => {
                that.timeout = false
              })
            })
          }
        }
      },
      videoLeft() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.videoposi
        let swich = this.$refs.videoswichs
        // console.log(posi.offsetWidth ,this.vchildLendth);
        if (posi.offsetWidth > this.vchildLendth) {

        } else {
          let that = this
          if (posi.getBoundingClientRect().left - swich.getBoundingClientRect().left == this.vchildLendth - posi.offsetWidth) {
            // console.log(posi.getBoundingClientRect().left,swich.getBoundingClientRect().left,this.vchildLendth-posi.offsetWidth);
            return
          } else {
            if (this.vtimeout) return
            window.requestAnimationFrame(function fn() {
              that.vindex -= 1
              const width = (that.vindex * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.vtimeout = true
              swich.addEventListener("transitionend", () => {
                that.vtimeout = false
              })
            })
          }
        }
      },
      videoRight() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.videoposi
        let swich = this.$refs.videoswichs

        if (posi.offsetWidth > this.vchildLendth) {

        } else {
          if (posi.getBoundingClientRect().left == swich.getBoundingClientRect().left) {
            return
          } else {
            let that = this
            if (this.vtimeout) return
            window.requestAnimationFrame(function fn() {
              that.vindex += 1
              const width = (that.index * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.vtimeout = true
              swich.addEventListener("transitionend", () => {
                that.vtimeout = false
              })
            })
          }
        }
      },
      audioLeft() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.audioposi
        let swich = this.$refs.audioswichs
        if (posi.offsetWidth > this.achildLendth) {

        } else {
          let that = this
          if (posi.getBoundingClientRect().left - swich.getBoundingClientRect().left == this.achildLendth - posi.offsetWidth) {
            return
          } else {
            if (this.atimeout) return
            window.requestAnimationFrame(function fn() {
              that.aindex -= 1
              const width = (that.aindex * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.atimeout = true
              swich.addEventListener("transitionend", () => {
                that.atimeout = false
              })
            })
          }
        }
      },
      audioRight() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        let posi = this.$refs.audioposi
        let swich = this.$refs.audioswichs
        if (posi.offsetWidth > this.achildLendth) {

        } else {
          if (posi.getBoundingClientRect().left == swich.getBoundingClientRect().left) {
            return
          } else {
            let that = this
            if (this.atimeout) return
            window.requestAnimationFrame(function fn() {
              that.aindex += 1
              const width = (that.aindex * swich.children[0].clientWidth) / fontSize
              swich.style.transform = 'translateX(' + width + 'rem)'
              swich.style.transition = 'transform 1s'
              that.atimeout = true
              swich.addEventListener("transitionend", () => {
                that.atimeout = false
              })
            })
          }
        }
      },
      init() {
        const fontSize = getComputedStyle(window.document.documentElement)['font-size'].split('px')[0]
        if (this.activeName == 'GJ') {
          this.childLendth = 0
          this.$nextTick(() => {
            let swich = this.$refs.swichs
            if (swich.children.length != 0) {
              for (const key of swich.children) {
                this.childLendth += key.offsetWidth
              }
              this.$refs.posi.style = 'max-width:' + swich.children[0].offsetWidth * 6 / fontSize + 'rem'
            }
          });
        } else if (this.activeName == 'SP') {
          this.vchildLendth = 0
          this.$nextTick(() => {
            let swich = this.$refs.videoswichs
            if (swich.children.length != 0) {
              for (const key of swich.children) {
                this.vchildLendth += key.offsetWidth
              }
              this.$refs.videoposi.style = 'max-width:' + swich.children[0].offsetWidth * 3 / fontSize + 'rem'
            }
          });
        } else if (this.activeName == 'YP') {
          this.achildLendth = 0
          this.$nextTick(() => {
            let swich = this.$refs.audioswichs
            if (swich.children.length != 0) {
              for (const key of swich.children) {
                this.achildLendth += key.offsetWidth
              }
              this.$refs.audioposi.style = 'max-width:' + swich.children[0].offsetWidth * 3 / fontSize + 'rem'
            }
          });
        }
      },

      getDetail() {
        let params = {
          bookId: this.$route.query.bookId
        }
        getBookById(params).then(res => {
          if (res.data.code == 200 && res.data.data) {
            this.datalist = JSON.parse(JSON.stringify(res.data.data))
            // 提取元数据模版值
            let captionsId = this.datalist.find(e => e.captions == '元数据模板').attributeValue

            this.detailsName = this.$store.state.categoryData.find(e => e.id == captionsId).name

            if (this.detailsName == '精品图书' || this.detailsName == '古籍底本' || this.detailsName == '民俗图片') {
              this.activeName = 'GJ'
            } else if (this.detailsName == '民俗视频') {
              this.activeName = 'SP'
            } else {
              this.activeName = 'YP'
            }
            this.init()
            let con = [
              {
                title: '题名',
                field: 'bookName'
              },
              {
                title: '馆藏地址',
                field: 'address'
              },
              {
                title: '地区',
                field: 'collectionplace'
              },
              {
                title: '分类',
                field: 'category'
              },
              {
                title: '民族',
                field: 'nation'
              },
              {
                title: '页数',
                field: 'pages'
              },
              {
                title: '简介',
                field: 'brief'
              },
              {
                title: '基础价格',
                field: 'price'
              },
              {
                title: 'coverPicture',
                field: 'coverPicture'
              }
            ]
            con.forEach(e => {
              const ds = this.datalist.find(i => {
                return i.captions == e.title
              })
              if (ds) {
                this.bookDetails[e.field] = ds.attributeValue
              }
            });
          }
        })
      },
      setDatas() {
        return this.detailsName == '古籍底本' ? '在线阅读' : this.detailsName == '精品图书' ? '在线阅读' :
          this.detailsName == '民俗视频' ? '在线播放' : this.detailsName == '民俗视频' ? '在线观看' : this.detailsName == '民俗图片' ? '在线预览' : ''
      },
      async jumpClick(id, page) {
        if (sessionStorage.getItem('portal_user_info')) {
          addReadHistory({
            bookId: this.$route.query.bookId,
            bookName: this.bookDetails.bookName,
            userId: this.$store.state.userInfo.userId,
            userName: this.$store.state.userInfo.userName,
            typeId: this.$store.state.typeId
          }).then(res => {
            console.log(res);
          })
          if (this.detailsName == "古籍底本" || this.detailsName == '精品图书') {
            if (this.bookDetails.price) {
              let data = await this.jurisdiction(id, page)
              if (!data) {
                this.$router.push({
                  path: '/buying',
                  query: {
                    bookId: this.$route.query.bookId
                  }
                })
              }
            } else {
              this.$router.push({
                path: '/exhibition',
                query: {
                  bookId: id,
                  page: page
                }
              })

            }
          }
        } else {
          // this.$message({
          //     message: '请登录',
          //     type: "error",
          // });
          this.$refs.Login.openDialog(false);
        }

      },
      jurisdiction(id, page) {
        return new Promise((provide, inject) => {
          checkIfPermittedToRead({
            bookId: id,
            typeId: this.$store.state.typeId,
            publicIp: sessionStorage.getItem('publicIp')
          }).then(res => {
            if (res.data.code == 200) {
              if (!res.data.data) {
                provide(res.data.data)
              } else {
                this.$router.push({
                  path: '/exhibition',
                  query: {
                    bookId: id,
                    page: page
                  }
                })
              }
            }
          })
        })

      },
      getMaster() {
        getMasterSlaveCatalogue({
          bookId: this.$route.query.bookId,
          typeId: this.$store.state.typeId,

        }).then(res => {
          if (res.data.code == 200 && res.data.data) {
            this.Master = res.data.data[0]
          }
        })
      },
      // 推荐查询
      getBooks(name) {
        return new Promise((reject, provide) => {
          listHomePageRecommend({
            typeId: this.$store.state.typeId,
            column: name,
            pageName:'首页'
          }).then(res => {
            if (res.data.code == 200) {
              reject(res.data.data)
            }
          })
        })
      },
      async getInit() {
        let that = this
        const promises = ['古籍底本', '民俗视频', '民俗音频'].map(function (name) {
          return that.getBooks(name)
        });
        const [booksList, videoList, audioList] = await Promise.all(promises)
        this.recom = {
          booksList: booksList,
          videoList: videoList,
          audioList: audioList
        }
      },
      rowClick(e) {
        let type = e.relatedType
        let path = type == 0 || type == 1 ? '/resource/detail' : type == 2 ? '/resource/detailsAud' : type == 3 ? '/resource/videoshows' : ''
        this.$router.push({
          path: path,
          query: {
            bookId: e.bookId
          }
        })
      },
      getCataDatas() {
        listBookRelationByBookId({
          typeId: this.$store.state.typeId,
          bookId: this.$route.query.bookId,
          page: this.currPage,
          limit: 5,
        }).then(res => {
          if (res.data.code == 200) {
            this.count = res.data.code
            this.cataData = res.data.data.list
          }
        })
      },
      handerChange(val) {
        this.cataData = []
        this.currPage = val
        this.getCataDatas()
      },
      computers(item) {
        return item.relatedType == 0 ? require('../../assets/image/resource/guanlian.png') :
          item.relatedType == 1 ? require('../../assets/image/resource/fanyiben.png') :
            item.relatedType == 2 ? require('../../assets/image/resource/yinpin.png') :
              item.relatedType == 3 ? require('../../assets/image/resource/shipin.png') : ''
      }

    },
    watch: {
      '$route.query.bookId': {
        handler: function (news, old) {
          Object.assign(this.$data, this.$options.data.call(this))
          this.getDetail()
          this.getMaster()
          this.getInit()
          this.getCataDatas()
        },
        deep: true
      }
    }
  };
</script>

<style lang="less" scoped>
  .details {
    background: url('../../assets/image/resource/res_main.png');
    padding-top: 1.042rem;
    padding-bottom: 2.083rem;

    .details-nav {
      width: 62.5rem;
      height: 2.604rem;
      margin: 0 auto;
      background-color: #fff;

      .nav-box {
        display: flex;
        height: 100%;
        align-items: center;
        padding-left: 1.042rem;
        font-size: 0.833rem;
        color: #333333;

        .nav-box-img {
          margin-right: 0.625rem;

          .el-image {
            width: 0.677rem;
            height: 0.833rem;
          }
        }

        .details-bread {
          /deep/ .el-breadcrumb {
            .el-breadcrumb__item {
              .el-breadcrumb__inner.is-link {
                font-size: 0.833rem;
                color: #333333;
                font-weight: unset;
              }

              .el-breadcrumb__inner {
                color: #b1222b;
              }
            }
          }

        }
      }
    }

    .deataols-item {
      width: 62.5rem;
      margin: 0 auto;
      background-color: #fff;
      margin-top: 0.625rem;
      padding: 1.563rem;
      display: flex;

      .item-left {
        margin-right: 1.563rem;

        .image-border {
          width: 10.938rem;
          height: 15.625rem;
          border: solid 0.052rem #dedede;
          display: flex;
          justify-content: center;
          align-items: center;

          .image-content {
            background: url('../../assets/image/index/book.png') no-repeat;
            background-size: cover;
            width: 9.896rem;
            height: 13.75rem;
            position: relative;

            .image-content-bg {
              position: absolute;
              left: 0.781rem;
              top: 50%;
              transform: translateY(-50%);
              width: 3.49rem;
              height: 11.979rem;
              background-color: #f7eed9;
              display: flex;
              align-items: center;
              justify-content: center;

              .image-content-border {
                width: 2.865rem;
                height: 11.406rem;
                background-color: #f7eed9;
                border: solid 0.104rem #1d293b;
                display: flex;
                align-items: center;
                justify-content: center;

                .image-content-text {
                  font-size: 1.519rem;
                  letter-spacing: 0.3rem;
                  height: 100%;
                  color: #333333;
                  word-wrap: break-word;
                  word-break: break-all;
                  white-space: nowrap;
                  writing-mode: tb-rl;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  text-align: center;
                }
              }
            }
          }
        }

        .el-image {
          width: 10.938rem;
          height: 15.625rem;
        }

        .r-search-button {
          width: 7.292rem;
          height: 2.604rem;
          background-color: #b1222b;
          border-radius: 0.313rem;
          border: solid 0.052rem #cccccc;
          font-size: 1.042rem;
          color: #ffffff;
          text-align: center;
          line-height: 2.604rem;
          margin-left: 0.521rem;
          z-index: 1;
          cursor: pointer;
        }
      }

      .item-right {
        .item-right-top {
          display: flex;

          .right-top-class {
            background-color: #9aca2a;
            color: #fff;
            font-size: 0.8rem;
            width: auto;
            padding: 0 0.2rem;
            height: 1.146rem;
            line-height: 1.146rem;
            border-radius: 5px;
            margin-right: 0.781rem;
          }

          .right-top-txt {
            font-size: 1.146rem;
            color: #333333;
          }
        }

        .text-button {
          margin-top: 0.99rem;
          margin-bottom: 0.938rem;
          display: flex;
          justify-content: flex-start;

          .text-button-wid {
            font-size: 0.625rem;
            min-width: 5.479rem;
            display: flex;
            align-items: center;
            padding: 4px 12px;
            border-radius: 5px;
            border: 1px solid #dcdfe6;
            cursor: pointer;

            svg {
              margin-right: 0.3rem;
            }
          }

          .text-button-wid:hover {
            color: #fff;
            background-color: #b2262f;
            border-color: #b2262f;

            svg {
              path {
                fill: #fff !important;
              }

            }
          }

        }

        .right-box {
          width: 46.875rem;
          background-color: #faf8f2;
          border-radius: 0.313rem;
          border: 0.052rem dashed #dedede;
          padding: 1.25rem 1.198rem 1.198rem 1.042rem;
          display: flex;
          flex-wrap: wrap;

          .right-box-item {
            width: 50%;
            display: flex;
            padding-right: 0.5rem;
            line-height: 1.8;
            font-size: 0.833rem;
            .right-box-theme {
              width: 4rem;
              color: #808080;
              display: inline-block;
              text-align-last: justify;
            }

            .right-box-content {
              margin-left: 0.729rem;
              font-size: 0.833rem;
              color: #333333;
              line-height: 1.9;
              width: calc(100% - 4rem);
              display: flex;
              flex-wrap: wrap;
              align-items: center;

              .content-box {
                display: flex;
                justify-content: center;
                align-items: center;

                .el-image {
                  margin-right: 5px;
                  display: flex;
                }

                .content-items {
                  margin-right: 20px;
                  position: relative;
                  cursor: pointer;
                  overflow: hidden;
                  text-overflow: ellipsis; //多出部分用...代替
                  display: -webkit-box; //定义为盒子模型显示
                  -webkit-line-clamp: 1; //用来限制在一个块元素显示的文本的行数
                  -webkit-box-orient: vertical; //从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式）
                  max-width: 5rem;
                }
              }
            }
          }

          .right-box-item.right-box-item2 {
            width: 100%;
          }

        }
      }
    }

    .details-catalogue {
      width: 62.5rem;
      margin: 0 auto;
      background-color: #fff;
      margin-top: 1.024rem;
      padding: 1.25rem 1.563rem 1.563rem 1.563rem;

      .details-catalogue-top {
        display: flex;
        align-items: center;

        .el-image {
          width: 1.406rem;
          height: 1.042rem;
          margin-right: 0.469rem;
        }

        .catalogue-txt {
          font-size: 1.146rem;
          color: #333333;
        }
      }

      .catalogue-hen {
        margin-top: 0.833rem;
        width: 100%;
        height: 0.052rem;
        background-color: #dedede;
        margin-bottom: 1.094rem;
      }

      .details-catalogue-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .catalogue-box-title {
          font-size: 0.833rem;
          color: #333333;
        }

        .catalogue-caozuo {
          font-size: 0.833rem;
          color: #b1222b;
        }

      }

      .catalogue-hen.hen1 {
        background-color: #eeeeee;
      }
    }

    .details-recommend {
      width: 62.5rem;
      margin: 0 auto;
      background-color: #fff;
      margin-top: 1.024rem;
      padding: 1.25rem 1.563rem 1.563rem 1.563rem;

      /deep/ .el-tabs {
        .el-tabs__nav-wrap::after {
          height: 0.052rem;
          background-color: #dedede;
        }

        .el-tabs__nav-scroll {
          .el-tabs__nav {
            .el-tabs__active-bar {
              height: 0.104rem;
              background-color: #b1222b;
            }

            .el-tabs__item {
              font-size: 1.146rem;
              color: #333333;

              .tabs-image {
                display: flex;
                align-items: center;

                .el-image {
                  width: 1.406rem;
                  height: 1.042rem;
                }
              }

            }

            .el-tabs__item.is-active {
              color: #b1222b;
            }
          }
        }

        .el-tabs__content {
          .swich {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 2.135rem;

            .swich-left, .swich-right {
              .el-image {
                width: 1.25rem;
                height: 2.604rem;
              }
            }

            .swich-left {
              cursor: pointer;
              margin-right: 2.292rem;
              transform: rotate(180deg);
            }

            .swich-right {
              cursor: pointer;
              // margin-left: 2.917rem;
            }

            .index-swich-posi {
              max-width: 50.875rem;
              min-width: 7.24rem;
              position: relative;
              overflow-x: hidden;

              .swich-banners {
                display: flex;

                .banner-item {
                  padding-right: 1.771rem;

                  .el-image {
                    width: 7.292rem;
                    height: 10rem;
                  }

                  .banner-title, .banner-yizu {
                    font-size: 0.833rem;
                    letter-spacing: 0.042rem;
                    color: #333333;
                  }
                }
              }

            }

            .index-swich-posi.swich-video {
              height: auto;

              .swich-banners {
                .banner-item {
                  .el-image {
                    width: 14.688rem;
                    height: 8.229rem;
                  }
                }
              }
            }

          }
        }

      }
    }
  }
</style>
